import React from "react";

import { Text } from "@performyard/py-components";
import { FIELD_HISTORY_IMPORT_COLUMNS } from "@performyard/service-contracts";

import clientSideCSVDownload from "../../../../utils/downloadCSV";

const TEMPLATE_FILENAME = "field-history-import-template.csv";

const COLUMN_DESCRIPTIONS: Record<(typeof FIELD_HISTORY_IMPORT_COLUMNS)[number], string> = {
	Email: "The employee's PerformYard email",
	Field: "The PerformYard field name exactly, including capitalization, such as Salary",
	"Field Value": "The value as of the effective date",
	// Not just "in the past": the binding rule is the employee's own timeline, since an import can
	// never change a current value.
	"Effective Date": "MM/DD/YYYY, must be before the date of the employee's current value for that field",
};

// Headers only. Any invalid row rejects the whole file, so a sample row left in place would cost the
// admin an upload. No escaping: none of the column names contain a comma or a quote.
const downloadTemplate = () => clientSideCSVDownload(`${FIELD_HISTORY_IMPORT_COLUMNS.join(",")}\n`, TEMPLATE_FILENAME);

const ExpectedFormatPanel = () => (
	<section className="flex flex-col gap-4">
		<div className="flex flex-col gap-1">
			<Text size="paragraph-2" weight="semi-bold" color="neutral-9" overrideElement="h3">
				Expected format
			</Text>
			<Text size="paragraph-3" weight="regular" color="neutral-7">
				One row per change. If any row is invalid, the whole file is rejected.{" "}
				{/* `font:inherit` and the reset classes stand in for preflight, which this build omits. */}
				<button
					type="button"
					onClick={downloadTemplate}
					className="cursor-pointer border-none bg-transparent p-0 align-baseline text-primary-5 underline [font:inherit] hover:text-primary-7"
				>
					Download CSV template
				</button>
			</Text>
		</div>
		<div className="flex flex-col gap-2 rounded-1 border border-solid border-neutral-2 bg-neutral-1 p-4">
			{FIELD_HISTORY_IMPORT_COLUMNS.map((column) => (
				<div key={column} className="flex gap-4">
					<div className="w-32 shrink-0">
						<Text size="paragraph-3" weight="semi-bold" color="neutral-9">
							{column}
						</Text>
					</div>
					<Text size="paragraph-3" weight="regular" color="neutral-9">
						{COLUMN_DESCRIPTIONS[column]}
					</Text>
				</div>
			))}
		</div>
	</section>
);

export default ExpectedFormatPanel;
